import * as stylex from '@stylexjs/stylex'
import { ErrorFilled, InfoFilled, NoticeFilled, SuccessFilled } from '../Icons'
import { colors } from '../tokens/colors.stylex'
import { Snackbar, type SnackbarProps } from './Snackbar'

const IconComponentsMap = {
  info: InfoFilled,
  success: SuccessFilled,
  warning: NoticeFilled,
  error: ErrorFilled,
} as const

const SeverityColorMap = {
  info: colors.blue600,
  success: colors.green600,
  warning: colors.yellow600,
  error: colors.red600,
}

const solidVariantStyles = stylex.create({
  info: {
    backgroundColor: colors.blue600,
    color: colors.white,
  },
  success: {
    backgroundColor: colors.green600,
    color: colors.white,
  },
  warning: {
    backgroundColor: colors.yellow600,
    color: colors.white,
  },
  error: {
    backgroundColor: colors.red600,
    color: colors.white,
  },
})

const baseStyles = stylex.create({
  default: {
    backgroundColor: colors.white,
  },
  dark: {
    backgroundColor: colors.grey800,
    color: colors.white,
  },
})

export type SnackbarVariantSeverity = 'info' | 'success' | 'warning' | 'error'
export type SnackbarVariant = 'default' | 'solid'
export interface SnackbarVariantsProps extends SnackbarProps {
  severity?: SnackbarVariantSeverity
  variant?: SnackbarVariant
  customStyles?: {
    root?: stylex.StyleXStyles
    snackbar?: stylex.StyleXStyles
  }
}

export const SnackbarVariants = ({
  variant = 'default',
  severity = 'info',
  mode = 'light',
  xStyles,
  ...rest
}: SnackbarVariantsProps) => {
  const IconComponent = IconComponentsMap[severity]
  const isSolid = variant === 'solid'
  const isDark = mode === 'dark'

  // Icon color: white for solid variant, colored for default variant (both light and dark mode)
  const color = isSolid ? colors.white : SeverityColorMap[severity]

  return (
    <Snackbar
      mode={mode}
      icon={<IconComponent color={color} />}
      xStyles={{
        ...xStyles,
        snackbar: [
          isSolid ? solidVariantStyles[severity] : (isDark ? baseStyles.dark : baseStyles.default),
          xStyles?.snackbar,
        ],
      }}
      {...rest}
    />
  )
}
